import React from 'react';
import { StepperOrientationEnum, StepperWrapperProps } from './stepper-wrapper.type';
import { cn } from '@utils';

export const StepperWrapper: React.FC<StepperWrapperProps> = ({
	steps,
	currentStep,
	onStepChange,
	className = '',
	includeHeader = false,
	orientation = StepperOrientationEnum.HORIZONTAL,
	header,
}) => {
	const handleStepClick = (index: number) => {
		if (onStepChange && !steps[index].isDisabled) {
			onStepChange(index);
		}
	};

	header ??= (
		<div className={cn('flex w-full gap-4', orientation === 'vertical' ? 'w-64 flex-col' : 'flex-row')}>
			{steps.map((step, index) => (
				<div
					key={step.id}
					className={cn(
						'flex cursor-pointer items-center gap-2 rounded-lg p-3 transition-all',
						'bg-white hover:bg-gray-50',
						index === currentStep && 'bg-primary/10',
						step.isDisabled && 'cursor-not-allowed opacity-50',
						className
					)}
					onClick={() => handleStepClick(index)}
				>
					{step.title && <div className="text-sm font-medium">{step.title}</div>}
				</div>
			))}
		</div>
	);
	const step = steps[currentStep];
	return (
		<div className={cn('flex flex-col gap-8', orientation === 'vertical' ? 'flex-row' : 'flex-col', className)}>
			{includeHeader && header}
			<div className={cn('flex-1 rounded-lg bg-white', step?.className)}>{step?.content}</div>
		</div>
	);
};
